import { FunctionComponent } from 'react';
import SkillsGrid from './SkillsGrid';

type SkillsProps = {
  skills: string;
};

const Skills: FunctionComponent<SkillsProps> = ({ skills }) => {
  return (
    <>
      <div className="mt-12" id="skills">
        <h2 className="mb-6 text-xl font-bold text-friendly-pink">Skills</h2>
        <SkillsGrid skills={skills} />
      </div>
    </>
  );
};

export default Skills;
